module.exports = __webpack_public_path__ + "static/media/app&web_pic_cut.999e7691.png";